import { render } from "./SeckillGoods.vue?vue&type=template&id=a945c2c8&scoped=true&ts=true"
import script from "./SeckillGoods.vue?vue&type=script&lang=ts"
export * from "./SeckillGoods.vue?vue&type=script&lang=ts"

import "./SeckillGoods.vue?vue&type=style&index=0&id=a945c2c8&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a945c2c8"]])

export default __exports__